import React from 'react';
import AccountCreated from '../../../stories/components/OnboardingNew/PopUp/AccountCreated/AccountCreated';

const Success = () => {
    return(
        <AccountCreated />
    )
}

export default Success;